<template>
  <v-container
    :key="pageKey"
    fluid
    style="
      background: rgba(255, 255, 255, 0.9);
      min-width: 100%;
      min-height: 95vh;
      padding: 10px 20px;
      position: relative;
    "
  >
    <h6
      @click="closePage"
      style="
        border: 1px solid rgba(0, 0, 0, 0.3);
        border-radius: 5px;
        position: absolute;
        padding-top: 2px;
        width: 90px;
        cursor: pointer;
        z-index: 4;
      "
    >
      <v-icon style="position: relative; top: -1px">mdi-chevron-left</v-icon
      >kembali
    </h6>
    <div style="margin: 25px 0 65px 0; position: relative">
      <div
        style="position: sticky; top: 55px; z-index: 3; background-color: white"
      >
        <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.2)">
          <div
            class="d-flex justify-start align-start"
            style="position: relative"
          >
            <h4 class="pjca-title mb-2">DETAIL PJCA</h4>
            <v-tooltip bottom color="grey">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  x-small
                  text
                  icon
                  color="grey darken-2"
                  @click="loadPage"
                  style="position: relative; top: 12px"
                >
                  <v-icon small>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>refresh page</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <div class="actionButton" v-if="detail != null">
              <!-- Admin -->

              <div class="d-flex">
                <div
                  v-if="
                    getUserProfile.employee.id == detail.employee_id ||
                    isFinance
                  "
                >
                  <v-btn
                    v-if="detail.status == 0 && !isEdit"
                    type="button"
                    elevation="0"
                    color="primary"
                    class="white--text font-weight-bold ma-1"
                    style="font-size: 12px"
                    @click.prevent="editDetail"
                    :loading="loading"
                    small
                    :rounded="wWidth < 809"
                  >
                    Edit
                  </v-btn>
                  <v-btn
                    v-if="
                      detail.status == 0 &&
                      !isEdit &&
                      getUserProfile.employee.id == detail.employee_id
                    "
                    type="button"
                    elevation="0"
                    color="green"
                    class="white--text font-weight-bold ma-1"
                    style="font-size: 12px"
                    :loading="loading"
                    :disabled="loading"
                    small
                    :rounded="wWidth < 809"
                    @click.prevent="submitPjca"
                  >
                    Submit
                  </v-btn>
                  <v-btn
                    v-if="detail.status == 3 || detail.status == 4"
                    type="button"
                    elevation="0"
                    color="primary"
                    class="white--text font-weight-bold ma-1"
                    style="font-size: 12px"
                    @click.prevent="setDraftPjca"
                    :loading="loading"
                    :disabled="loading"
                    small
                    :rounded="wWidth < 809"
                  >
                    Set Draft
                  </v-btn>
                  </div>
                <div
                  v-if="(detail.status == 2 || detail.status == 0) && !isEdit"
                >
                  <v-btn
                    v-if="
                      detail.status == 0 &&
                      getUserProfile.employee.id == detail.employee_id
                    "
                    type="button"
                    elevation="0"
                    color="pink"
                    class="white--text font-weight-bold ma-1"
                    style="font-size: 12px"
                    :loading="loading"
                    :disabled="loading"
                    small
                    @click.prevent="cancelPjca"
                    :rounded="wWidth < 809"
                  >
                    Cancel PJCA
                  </v-btn>
                  <v-btn
                    v-if="detail.status == 2"
                    type="button"
                    elevation="0"
                    color="pink"
                    class="white--text font-weight-bold ma-1"
                    style="font-size: 12px"
                    :loading="loading"
                    :disabled="loading"
                    small
                    @click.prevent="cancelPjca"
                    :rounded="wWidth < 809"
                  >
                    Cancel PJCA
                  </v-btn>
                </div>
                <div v-if="isAllow">
                  <div v-if="detail.status == 1">
                    <div
                      v-if="
                        detail.approver_users.find(
                          (e) => e == getUserProfile.employee.email
                        ) != undefined
                      "
                    >
                      <v-btn
                        type="button"
                        elevation="0"
                        color="green"
                        class="white--text font-weight-bold ma-1"
                        style="font-size: 12px"
                        :loading="loading"
                        :disabled="loading"
                        small
                        :rounded="wWidth < 809"
                        @click="validateBeforeConfirm"
                      >
                        Confirm
                      </v-btn>
                      <v-btn
                        type="button"
                        elevation="0"
                        color="pink"
                        class="white--text font-weight-bold ma-1"
                        style="font-size: 12px"
                        :loading="loading"
                        :disabled="loading"
                        small
                        :rounded="wWidth < 809"
                        @click="rejectPjca"
                      >
                        Reject
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <v-row no-gutters v-if="detail != null">
          <v-col cols="4">
            <p style="font-size: 12px">
              Tgl. PJCA: {{ convertDate(detail.createdAt) }} |
              {{ detail.created_by_name }}
            </p>
          </v-col>
          <v-col cols="4">
            <p style="font-size: 12px">
              Tgl. CA:
              {{
                detail.payment_request != null
                  ? convertDate(detail.payment_request.created_at)
                  : ''
              }}
              |
              {{ detail.created_by_name }}
            </p>
          </v-col>
          <v-col cols="4">
            <div class="d-flex justify-end">
              <p
                :style="`background-color: ${statusColor(detail.status)};
                color: white;
                font-weight: bold;
                margin: 5px 0 0 0;
                padding: 0 10px;
                border: 1px solid rgba(0, 0, 0, 0.6);
                width: 180px;
                text-align: center;`"
              >
                {{ statusName(detail.status) }}
              </p>
            </div>
          </v-col>
        </v-row>
      </div>
      <v-row v-if="detail != null" no-gutters style="margin-top: 40px">
        <v-col cols="12" md="4" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            No. Dokumen
          </p>

          <v-text-field
            :value="detail.document_no"
            dense
            readonly
            style="font-size: 12px; height: 45px"
          />
        </v-col>
        <v-col cols="12" md="4" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            No. Payment Request
            <v-tooltip right color="info">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  @click="openDetailPayreq(detail.payment_request)"
                  style="cursor: pointer"
                  x-small
                  color="primary"
                >
                  mdi-open-in-new
                </v-icon>
              </template>
              <span>Lihat detail Payreq</span>
            </v-tooltip>
          </p>

          <v-text-field
            :value="
              detail.payment_request != null
                ? detail.payment_request.document_no
                : ''
            "
            dense
            readonly
            style="font-size: 12px; height: 45px"
          />
        </v-col>
        <v-col cols="12" md="4" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            PIC
          </p>

          <v-text-field
            :value="detail.employee_name"
            dense
            readonly
            style="font-size: 12px; height: 45px"
          />
        </v-col>
        <v-col cols="12" md="4" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            Perusahaan
          </p>

          <v-text-field
            :value="detail.company_name"
            dense
            readonly
            style="font-size: 12px; height: 45px"
          />
        </v-col>
        <v-col cols="12" md="4" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            Dari Departemen
          </p>

          <v-text-field
            :value="detail.department_name"
            dense
            readonly
            style="font-size: 12px; height: 45px"
          />
        </v-col>
        <v-col cols="12" md="4" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            Kepada Departemen
          </p>

          <v-text-field
            :value="detail.to_department_name"
            dense
            readonly
            style="font-size: 12px; height: 45px"
          />
          <!-- <v-autocomplete
            v-else
            v-model="detail.to_department"
            :items="dropdown.department"
            readonly
            item-text="name"
            item-value="id"
            style="font-size: 12px; height: 45px"
            return-object
            dense
            outlined
            clearable
          ></v-autocomplete> -->
        </v-col>
        <!--
        <v-col cols="12" md="9" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            Vendor
          </p>

          <v-text-field
            v-model="detail.vendor_name"
            :outlined="isEdit"
            :clearable="isEdit"
            :readonly="!isEdit"
            :disabled="isEdit && isFinance"
            dense
            style="font-size: 12px; height: 45px"
          />
        </v-col>
        <v-col cols="3"> </v-col>
        <v-col
          cols="12"
          md="3"
          class="d-flex flex-column pl-3 pr-3"
        >
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            Nama Bank
          </p>

          <v-text-field
            v-model="detail.bank_name"
            :outlined="isEdit"
            :clearable="isEdit"
            :readonly="!isEdit"
            :disabled="isEdit && isFinance"
            dense
            style="font-size: 12px; height: 45px"
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
          class="d-flex flex-column pl-3 pr-3"
        >
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            No. Rekening
          </p>

          <v-text-field
            v-model="detail.account_number"
            :outlined="isEdit"
            :clearable="isEdit"
            :readonly="!isEdit"
            :disabled="isEdit && isFinance"
            dense
            style="font-size: 12px; height: 45px"
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
          class="d-flex flex-column pl-3 pr-3"
        >
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            Atas Nama
          </p>

          <v-text-field
            v-model="detail.account_name"
            :outlined="isEdit"
            :clearable="isEdit"
            :readonly="!isEdit"
            :disabled="isEdit && isFinance"
            dense
            style="font-size: 12px; height: 45px"
          />
        </v-col> -->
      </v-row>

      <v-card v-if="detail != null" style="margin-top: 10px">
        <v-tabs
          v-model="tab"
          background-color="rgb(240,240,240)"
          slider-color="primary"
          color="primary"
        >
          <v-tab :disabled="isEdit" v-for="item in items" :key="item.tab">
            {{ item.tab }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item
            v-for="item in items"
            :key="item.tab"
            style="padding: 20px"
          >
            <div style="min-height: 60vh">
              <div v-if="item.tab == 'Detail Barang'">
                <div style="position: relative">
                  <v-data-table
                    v-model="selectedData"
                    :loading="loading"
                    height="30vh"
                    mobile-breakpoint="0"
                    :dense="wWidth > 808 ? true : false"
                    style="
                      cursor: pointer;
                      border: 1px solid rgba(0, 0, 0, 0.2);
                    "
                    :headers="pjcaHeaders"
                    :items="detail.pjca_detail"
                    :items-per-page="10"
                    @click:row="rowClick"
                    :search="searchItem"
                    :custom-filter="customSearch"
                    :options.sync="options"
                    :show-select="
                      getUserProfile.level.find(({ id }) => id === '41') ===
                        undefined && detail.status == 0
                    "
                    item-key="id"
                  >
                    <template v-slot:top>
                      <div
                        style="
                          border: thin solid rgba(0, 0, 0, 0.12);
                          cursor: auto;
                          padding: 0 15px;
                          height: 75px;
                          display: flex;
                          overflow: hidden;
                        "
                      >
                        <div
                          style="
                            display: flex;
                            align-items: center;
                            margin: 0 15px 0 5px;
                          "
                        >
                          <v-btn
                            v-if="detail.status == 0"
                            @click="openItemForm"
                            style="font-size: 10px"
                            elevation="2"
                            tilerounded="5px"
                            x-small
                            color="primary"
                            class="white--text"
                          >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" small class="">
                                  mdi-plus
                                </v-icon>
                              </template>
                              <span>Tambah item</span>
                            </v-tooltip>
                          </v-btn>
                        </div>
                        <div style="width: 120px">
                          <v-select
                            :disabled="selectedData.length === 0"
                            label="Action"
                            style="
                              position: relative;
                              top: 15px;
                              margin: 0 15px 0 5px;
                              font-size: 12px;
                            "
                            v-model="actionValue"
                            :items="itemsAction"
                            item-text="name"
                            item-value="id"
                            outlined
                            return-id
                            dense
                            @change="actionSelect"
                          ></v-select>
                        </div>
                        <div
                          style="
                            width: 260px;
                            position: relative;
                            top: 15px;
                            margin: 0 15px 0 5px;
                            font-size: 12px;
                            height: 45px;
                          "
                        >
                          <v-text-field
                            v-model="searchItem"
                            label="Cari barang"
                            outlined
                            dense
                          ></v-text-field>
                        </div>
                        <v-spacer></v-spacer>
                        <div style="display: flex; align-items: center">
                          <v-btn
                            elevation="0"
                            color="transparent"
                            small
                            outlined
                            style="margin-right: 10px"
                            :loading="loading"
                            @click="downloadDokumen"
                          >
                            <v-icon
                              color="primary"
                              small
                              style="margin-right: 5px"
                              >mdi-file-outline</v-icon
                            >
                            <a href="#" style="font-weight: bold"
                              >File Pendukung</a
                            >
                          </v-btn>
                          <v-btn
                            elevation="0"
                            color="transparent"
                            small
                            outlined
                            style="margin-right: 10px"
                            :loading="loading"
                            @click="generatePdfPjca"
                          >
                            <v-icon
                              color="primary"
                              small
                              style="margin-right: 5px"
                              >mdi-magnify
                            </v-icon>
                            <a href="#" style="font-weight: bold">Lihat PDF</a>
                          </v-btn>
                        </div>
                      </div>
                    </template>
                    <!-- <template v-slot:[`item.no`]="{ index }">
                    <div style="width: 35px">
                      {{ index + 1 }}
                    </div>
                  </template> -->
                    <template v-slot:[`item.product_code`]="{ item }">
                      <div style="width: 95px; font-size: 12px">
                        {{ item.product_code }}
                      </div>
                    </template>
                    <template v-slot:[`item.product_name`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="on"
                            style="
                              text-align: left;
                              width: 250px;
                              font-size: 12px;
                              padding: 0;
                            "
                          >
                            {{
                              `${
                                item.product_code !== null
                                  ? '(' + item.product_code + ')'
                                  : ''
                              } ${item.product_name}`
                            }}
                          </div>
                        </template>
                        <span>
                          {{
                            `${
                              item.product_code !== null
                                ? '(' + item.product_code + ')'
                                : ''
                            } ${item.product_name}`
                          }}</span
                        >
                      </v-tooltip>
                    </template>
                    <template v-slot:[`item.uom_name`]="{ item }">
                      <div style="width: 45px; font-size: 12px">
                        {{ item.uom_name }}
                      </div>
                    </template>
                    <!-- <template v-slot:[`item.qty_request`]="{ item }">
                    <div style="font-size: 12px">
                      {{ item.qty_request }}
                    </div>
                  </template> -->
                    <template v-slot:[`item.qty_done`]="{ item }">
                      <div style="font-size: 12px">
                        {{ item.qty_done }}
                      </div>
                    </template>
                    <!-- <template v-slot:[`item.price_request`]="{ item }">
                    <div style="width: 105px; font-size: 12px">
                      {{ item.price_request }}
                    </div>
                  </template> -->
                    <template v-slot:[`item.price_done`]="{ item }">
                      <div style="width: 105px; font-size: 12px">
                        {{ priceConvert(item.price_done) }}
                      </div>
                    </template>
                    <!-- <template v-slot:[`item.price_total`]="{ item }">
                    <div style="width: 120px; font-size: 12px">
                      {{ item.price_total }}
                    </div>
                  </template> -->
                    <template v-slot:[`item.discount_percent`]="{ item }">
                      <div style="width: 75px; font-size: 12px">
                        {{ priceConvert(item.discount_percent) }}
                      </div>
                    </template>
                    <template v-slot:[`item.discount_amount`]="{ item }">
                      <div style="width: 105px; font-size: 12px">
                        {{ priceConvert(item.discount_amount) }}
                      </div>
                    </template>
                    <template v-slot:[`item.total_discount`]="{ item }">
                      <div style="width: 105px; font-size: 12px">
                        {{ priceConvert(item.total_discount) }}
                      </div>
                    </template>
                    <template v-slot:[`item.tax_type`]="{ item }">
                      <div style="width: 105px; font-size: 12px">
                        <v-chip
                          x-small
                          color="grey"
                          v-if="
                            dropdown.tax.find(
                              ({ id }) => id == item.tax_type
                            ) != undefined
                          "
                          style="font-size: 10px; font-weight: bold"
                        >
                          {{
                            dropdown.tax.find(({ id }) => id == item.tax_type)
                              .name
                          }}
                        </v-chip>
                        <span v-else></span>
                        <!-- <v-autocomplete
                        v-model="item.tax"
                        :items="dropdown.tax"
                        item-text="name"
                        item-value="id"
                        style="font-size: 12px; height: 45px"
                        return-id
                        dense
                        clearable
                        readonly
                        append-icon=""
                      ></v-autocomplete> -->
                      </div>
                    </template>
                    <template v-slot:[`item.subtotal`]="{ item }">
                      <div style="width: 105px; font-size: 12px">
                        {{ priceConvert(item.subtotal) }}
                      </div>
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                      <div style="width: 215px; font-size: 12px">
                        {{ item.description }}
                      </div>
                    </template>
                    <template
                      v-slot:[`item.purchase_request_detail`]="{ item }"
                    >
                      <div style="font-size: 12px" class="item-relative">
                        <v-btn
                          x-small
                          icon
                          color="blue"
                          @click.stop="
                            openStoreLink(item.purchase_request_detail)
                          "
                        >
                          <v-icon x-small>mdi-open-in-new</v-icon>
                        </v-btn>
                      </div>
                    </template>
                  </v-data-table>

                  <div
                    v-if="isEdit"
                    style="
                      position: absolute;
                      top: 0;
                      left: 0;
                      right: 0;
                      bottom: 0;
                      background-color: rgba(0, 0, 0, 0.1);
                    "
                  ></div>
                </div>
                <div class="items-total-div-2 mt-5">
                  <v-card elevation="0" class="items-difference-box">
                    <div
                      v-if="
                        detail != null &&
                        detail.payment_request != null &&
                        Math.abs(
                          detail.total_price -
                            detail.payment_request.total_price
                        ) > 0
                      "
                      style="margin: 10px"
                    >
                      <v-toolbar-title class="overline">
                        <p
                          style="
                            font-size: 14px;
                            margin: 0;
                            font-weight: bold;
                            margin-bottom: 10px;
                          "
                        >
                          Selisih dana dibayarkan kepada
                        </p>
                      </v-toolbar-title>

                      <v-row no-gutters>
                        <v-col
                          cols="12"
                          md="4"
                          class="d-flex flex-column pl-3 pr-3"
                        >
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Bank
                          </p>
                          <v-text-field
                            v-if="isEdit"
                            v-model="detail.bank_name"
                            :outlined="isEdit"
                            dense
                            style="font-size: 12px; height: 45px"
                          />
                          <v-text-field
                            v-else
                            :value="detail.bank_name"
                            dense
                            readonly
                            style="font-size: 12px; height: 45px"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                          class="d-flex flex-column pl-3 pr-3"
                        >
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            No. Rekening
                          </p>
                          <v-text-field
                            v-if="isEdit"
                            v-model="detail.account_number"
                            :outlined="isEdit"
                            dense
                            style="font-size: 12px; height: 45px"
                          />
                          <v-text-field
                            v-else
                            :value="detail.account_number"
                            dense
                            readonly
                            style="font-size: 12px; height: 45px"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                          class="d-flex flex-column pl-3 pr-3"
                        >
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Atas Nama
                          </p>
                          <v-text-field
                            v-if="isEdit"
                            v-model="detail.account_name"
                            :outlined="isEdit"
                            dense
                            style="font-size: 12px; height: 45px"
                          />
                          <v-text-field
                            v-else
                            :value="detail.account_name"
                            dense
                            readonly
                            style="font-size: 12px; height: 45px"
                          />
                        </v-col>
                      </v-row>
                    </div>

                    <div
                      v-if="detail != null && detail.status == 0 && isEdit"
                      style="margin: 30px 10px 10px 10px"
                    >
                      <v-toolbar-title class="overline">
                        <p
                          style="
                            font-size: 14px;
                            margin: 0;
                            font-weight: bold;
                            margin-bottom: 10px;
                          "
                        >
                          Discount & Biaya Tambahan
                        </p>
                      </v-toolbar-title>
                      <v-row no-gutters>
                        <v-col
                          cols="12"
                          md="4"
                          class="d-flex flex-column pl-3 pr-3"
                        >
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Biaya Pengiriman
                          </p>
                          <!-- :readonly="!isEdit || (detail.global_discount != null && detail.global_discount != 0)" -->
                          <v-text-field
                            v-if="isEdit"
                            v-model="detail.delivery_costs"
                            :outlined="isEdit"
                            type="number"
                            min="0"
                            dense
                            style="font-size: 12px; height: 45px"
                          />
                          <v-text-field
                            v-else
                            :value="priceConvert(detail.delivery_costs)"
                            dense
                            readonly
                            style="font-size: 12px; height: 45px"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                          class="d-flex flex-column pl-3 pr-3"
                        >
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Biaya Layanan
                          </p>
                          <!-- :readonly="!isEdit || (detail.global_discount != null && detail.global_discount != 0)" -->
                          <v-text-field
                            v-if="isEdit"
                            v-model="detail.service_costs"
                            :outlined="isEdit"
                            type="number"
                            min="0"
                            dense
                            style="font-size: 12px; height: 45px"
                          />
                          <v-text-field
                            v-else
                            :value="priceConvert(detail.service_costs)"
                            dense
                            readonly
                            style="font-size: 12px; height: 45px"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                          class="d-flex flex-column pl-3 pr-3"
                        >
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Biaya Lain-lain
                          </p>
                          <!-- :readonly="!isEdit || (detail.global_discount != null && detail.global_discount != 0)" -->
                          <v-text-field
                            v-if="isEdit"
                            v-model="detail.other_costs"
                            :outlined="isEdit"
                            type="number"
                            min="0"
                            dense
                            style="font-size: 12px; height: 45px"
                          />
                          <v-text-field
                            v-else
                            :value="priceConvert(detail.other_costs)"
                            dense
                            readonly
                            style="font-size: 12px; height: 45px"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                          class="d-flex flex-column pl-3 pr-3"
                        >
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Disc Global (%)
                          </p>

                          <v-text-field
                            v-model="detail.global_discount_percent"
                            :readonly="!isEdit"
                            :outlined="isEdit"
                            @change="globalPercentWatcher"
                            type="number"
                            min="0"
                            dense
                            style="font-size: 12px; height: 45px"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                          class="d-flex flex-column pl-3 pr-3"
                        >
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Disc Global (nominal)
                          </p>

                          <v-text-field
                            v-if="isEdit"
                            v-model="detail.global_discount"
                            :outlined="isEdit"
                            @change="globalAmountWatcher"
                            type="number"
                            min="0"
                            dense
                            style="font-size: 12px; height: 45px"
                          />
                          <v-text-field
                            v-else
                            :value="priceConvert(detail.global_discount)"
                            dense
                            readonly
                            style="font-size: 12px; height: 45px"
                          />
                        </v-col>
                        <v-col cols="12" md="4"></v-col>
                        <v-col
                          cols="12"
                          md="4"
                          class="d-flex flex-column pl-3 pr-3"
                        >
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            PPh (%)
                          </p>

                          <v-text-field
                            v-model="detail.pph_percent"
                            :readonly="!isEdit"
                            :outlined="isEdit"
                            @change="pphPercentWatcher"
                            type="number"
                            min="0"
                            dense
                            style="font-size: 12px; height: 45px"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                          class="d-flex flex-column pl-3 pr-3"
                        >
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            PPh (nominal)
                          </p>

                          <v-text-field
                            v-if="isEdit"
                            v-model="detail.pph_amount"
                            :outlined="isEdit"
                            @change="pphAmountWatcher"
                            type="number"
                            min="0"
                            dense
                            style="font-size: 12px; height: 45px"
                          />
                          <v-text-field
                            v-else
                            :value="priceConvert(detail.pph_amount)"
                            dense
                            readonly
                            style="font-size: 12px; height: 45px"
                          />
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>
                  <v-card elevation="1" class="items-total-box">
                    <div style="font-size: 12px">
                      <p>Harga dasar <span>:</span></p>
                      <p style="text-align: right; width: 100%">
                        {{ priceConvert(detail.total_base_price) }}
                      </p>
                    </div>
                    <div
                      v-if="
                        detail.delivery_costs != null &&
                        detail.delivery_costs > 0
                      "
                      style="font-size: 12px"
                    >
                      <p>Biaya Pengiriman <span>:</span></p>
                      <p
                        @dblclick="editDetail"
                        style="text-align: right; width: 100%"
                      >
                        {{ priceConvert(detail.delivery_costs) }}
                      </p>
                      <!-- <p
                        v-if="!isEdit"
                        @dblclick="editDetail"
                        style="text-align: right; width: 100%"
                      >
                        {{ price(detail.delivery_costs) }}
                      </p>
                      <div
                        v-else
                        style="
                          height: 25px;
                          width: 130px;
                          margin: 0;
                          padding: 0;
                          margin-left: auto;
                        "
                        class="d-flex justify-center align-center"
                      >
                        <v-text-field
                          v-model="detail.delivery_costs"
                          type="number"
                          min="0"
                          dense
                          reverse
                          style="
                            font-size: 12px;
                            padding: 0;
                            margin: 0;
                            height: 25px;
                          "
                        />
                      </div> -->
                    </div>
                    <div
                      v-if="
                        detail.service_costs != null && detail.service_costs > 0
                      "
                      style="font-size: 12px"
                    >
                      <p>Biaya Layanan <span>:</span></p>
                      <p style="text-align: right; width: 100%">
                        {{ priceConvert(detail.service_costs) }}
                      </p>
                    </div>
                    <div
                      v-if="
                        detail.other_costs != null && detail.other_costs > 0
                      "
                      style="font-size: 12px"
                    >
                      <p>Lain-lain <span>:</span></p>
                      <p style="text-align: right; width: 100%">
                        {{ priceConvert(detail.other_costs) }}
                      </p>
                    </div>
                    <div style="font-size: 12px">
                      <p>Total Diskon<span>:</span></p>
                      <p style="text-align: right; width: 100%">
                        {{ priceConvert(detail.total_discount) }}
                      </p>
                    </div>
                    <div style="font-size: 12px">
                      <p>Disc Global (%)<span>:</span></p>
                      <p style="text-align: right; width: 100%">
                        {{ priceConvert(detail.global_discount_percent) }}
                      </p>
                    </div>
                    <div style="font-size: 12px">
                      <p>Disc Global (nominal)<span>:</span></p>
                      <p style="text-align: right; width: 100%">
                        {{ priceConvert(detail.global_discount) }}
                      </p>
                    </div>
                    <div style="font-size: 12px">
                      <p>Nominal Sebelum Pajak <span>:</span></p>
                      <p style="text-align: right; width: 100%">
                        {{ priceConvert(detail.untaxed_amount) }}
                      </p>
                    </div>
                    <div style="font-size: 12px">
                      <p>DPP <span>:</span></p>
                      <p style="text-align: right; width: 100%">
                        {{ priceConvert(detail.total_dpp) }}
                      </p>
                    </div>
                    <div style="font-size: 12px">
                      <p>PPN <span>:</span></p>
                      <p style="text-align: right; width: 100%">
                        {{ priceConvert(detail.total_tax_amount) }}
                      </p>
                    </div>
                    <div style="font-size: 12px">
                      <p>PPh ({{ detail.pph_percent }}%) <span>:</span></p>
                      <p style="text-align: right; width: 100%">
                        - {{ priceConvert(detail.total_pph_amount) }}
                      </p>
                    </div>
                    <div style="font-size: 14px; font-weight: bold">
                      <p>Total PJCA<span>:</span></p>
                      <p style="text-align: right; width: 100%">
                        {{ priceConvert(detail.total_price) }}
                      </p>
                    </div>
                    <div
                      v-if="detail.difference_price != null"
                      style="font-size: 12px"
                    >
                      <p>Total CA <span>:</span></p>
                      <p style="text-align: right; width: 100%">
                        {{ priceConvert(detail.payment_request.total_price) }}
                      </p>
                    </div>
                    <div
                      v-if="detail.difference_price != null"
                      style="font-size: 12px; font-weight: bold"
                    >
                      <p>SELISIH <span>:</span></p>
                      <p style="text-align: right; width: 100%">
                        {{ priceConvert(detail.difference_price) }}
                      </p>
                    </div>
                  </v-card>
                </div>
              </div>

              <div v-if="item.tab == 'Approval'">
                <div style="margin-top: 20px">
                  <v-row no-gutters style="padding: 0">
                    <v-col md="12" style="padding: 0">
                      <!-- <div
                        style="
                          margin-left: 5px;
                          font-weight: bold;
                          margin-bottom: 10px;
                          border-bottom: 1px solid rgba(0, 0, 0, 0.4);
                        "
                      >
                        APPROVAL MATRIX
                      </div> -->
                      <v-data-table
                        mobile-breakpoint="0"
                        :headers="approvalHeaders"
                        :items="
                          detail.approval_matrix != null
                            ? detail.approval_matrix
                            : []
                        "
                        :items-per-page="10"
                        class="elevation-1 mx-auto"
                        hide-default-footer
                      >
                        <template v-slot:[`item.document_no`]="{ item }">
                          <div style="width: 140px; font-size: 12px">
                            {{ item.document_no }}
                          </div>
                        </template>
                        <template v-slot:[`item.table_name`]="{ item }">
                          <div style="width: 140px; font-size: 12px">
                            {{ item.table_name }}
                          </div>
                        </template>
                        <template v-slot:[`item.approver_user`]="{ item }">
                          <div style="cursor: pointer" v-if="item">
                            <v-chip
                              label
                              outlined
                              small
                              style="
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                                border: 1px solid rgba(0, 0, 0, 0.5);
                              "
                              v-for="(item, index) in item.approver_user"
                              :key="index"
                            >
                              {{ item.user !== null ? item.user.name : '-' }}
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:[`item.approved`]="{ item }">
                          <div
                            v-for="(items, index) in item.approver_user"
                            :key="index"
                            style="width: 140px"
                          >
                            <v-chip
                              v-if="items.status === 1"
                              label
                              outlined
                              small
                              style="
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                                border: 1px solid rgba(0, 0, 0, 0.5);
                              "
                            >
                              {{ item.user !== null ? items.user.name : '-' }}
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:[`item.rejected`]="{ item }">
                          <div
                            v-for="(items, index) in item.approver_user"
                            :key="index"
                            style="width: 140px"
                          >
                            <v-chip
                              v-if="items.status === -1"
                              label
                              outlined
                              small
                              style="
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                                border: 1px solid rgba(0, 0, 0, 0.5);
                              "
                            >
                              {{ item.user !== null ? items.user.name : '-' }}
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:[`item.created_at`]="{ item }">
                          <div style="width: 140px; font-size: 12px">
                            {{ item.created_at }}
                          </div>
                        </template>
                        <template v-slot:[`item.updated_at`]="{ item }">
                          <!-- <div style="width:140px; fontSize:12px;">
                            {{ item.approver_user[item.approver_user.length -1]. }}
                          </div> -->
                          <div
                            v-for="(items, index) in item.approver_user"
                            :key="index"
                            style="width: 140px; font-size: 12px"
                          >
                            <span v-if="items.status === 1">
                              {{
                                items.updated_at !== null
                                  ? items.updated_at
                                  : '-'
                              }}
                            </span>
                            <br v-if="index > 0" />
                          </div>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <div
                    v-if="
                      getUserProfile.level.find(({ id }) => id === '41') ===
                      undefined
                    "
                  >
                    <div
                      style="
                        text-align: left;
                        padding-left: 5px;
                        margin-top: 5px;
                      "
                      v-if="detail.status === 1"
                    >
                      <v-btn
                        v-if="
                          getUserProfile.level.find(
                            ({ id }) => id === '1' || id === '26' || id === '30'
                          ) !== undefined ||
                          isFinance ||
                          getUserProfile.employee.id == detail.employee_id
                        "
                        color="grey"
                        tile
                        dark
                        small
                        dense
                        style="font-size: 10px; width: 100px"
                        @click="checkBeforeFetch"
                        :loading="loading"
                      >
                        <span>Fetch Matrix</span>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
      <v-row v-if="detail != null" no-gutters style="margin-top: 10px">
        <v-col
          v-if="detail.canceled_reason"
          cols="12"
          class="d-flex flex-column pl-3 pr-3"
        >
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgb(250, 0, 0);
            "
          >
            Alasan Cancel
          </p>

          <v-textarea
            :value="detail.canceled_reason"
            dense
            :auto-grow="true"
            rows="1"
            disabled
            color="red"
            clear-icon="mdi-close-circle"
          ></v-textarea>
        </v-col>
        <v-col
          v-if="detail.rejected_reason"
          cols="12"
          class="d-flex flex-column pl-3 pr-3"
        >
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgb(250, 0, 0);
            "
          >
            Alasan Reject
          </p>

          <v-textarea
            :value="detail.rejected_reason"
            dense
            :auto-grow="true"
            rows="1"
            clear-icon="mdi-close-circle"
            disabled
            color="red"
          ></v-textarea>
        </v-col>
      </v-row>
    </div>
    <div>
      <FormItemPjca
        :act="act"
        :detail="detail"
        :itemDetail="itemDetail"
        :proc="proc"
        @loadPage="loadPage"
      />
    </div>
    <v-snackbar
      top
      elevation="0"
      color="white"
      v-model="snackbar"
      :timeout="timeout"
    >
      <v-alert outlined type="error" prominent border="left">
        {{ alertText }}
      </v-alert>
    </v-snackbar>
    <v-dialog
      v-if="detail !== null"
      v-model="editHeaderDialog"
      width="700"
      persistent
    >
      <v-form
        :disabled="loading"
        lazy-validation
        ref="editHeaderForm"
        @submit.prevent="saveChange"
        style="position: relative"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Edit Header PJCA
          </v-card-title>
          <v-card-text class="d-flex justify-center align-center">
            <v-col cols="12" style="padding: 0; position: relative; top: 15px">
              <v-row no-gutters>
                <v-col cols="12" md="6" style="padding: 0 4px">
                  <v-select
                    v-model="editForm.to_department_id"
                    :items="dropdown.department"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    label="Kepada Departemen *"
                    style="margin: 0"
                  ></v-select>
                </v-col>
              </v-row>
              <v-divider
                v-if="
                  detail != null &&
                  detail.payment_request != null &&
                  Math.abs(
                    detail.total_price - detail.payment_request.total_price
                  ) > 0
                "
                class="mt-2 mb-3"
              ></v-divider>
              <v-row
                v-if="
                  detail != null &&
                  detail.payment_request != null &&
                  Math.abs(
                    detail.total_price - detail.payment_request.total_price
                  ) > 0
                "
                no-gutters
              >
                <v-col cols="12">
                  <v-toolbar-title class="overline">
                    <p
                      style="
                        font-size: 14px;
                        margin: 0;
                        font-weight: bold;
                        margin-bottom: 10px;
                      "
                    >
                      Selisih dana dibayarkan kepada
                    </p>
                  </v-toolbar-title>
                </v-col>
                <v-col cols="12" md="6" style="padding: 0 4px">
                  <v-text-field
                    v-model="editForm.vendor_name"
                    dense
                    outlined
                    label="Vendor"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" md="6" style="padding: 0 4px">
                  <v-text-field
                    v-model="editForm.bank_name"
                    dense
                    outlined
                    label="Bank"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" md="6" style="padding: 0 4px">
                  <v-text-field
                    v-model="editForm.account_number"
                    dense
                    outlined
                    label="No. Rekening"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" md="6" style="padding: 0 4px">
                  <v-text-field
                    v-model="editForm.account_name"
                    dense
                    outlined
                    label="Atas Nama"
                    style="margin: 0"
                  />
                </v-col>
              </v-row>
              <v-divider class="mt-2 mb-3"></v-divider>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-toolbar-title class="overline">
                    <p
                      style="
                        font-size: 14px;
                        margin: 0;
                        font-weight: bold;
                        margin-bottom: 10px;
                      "
                    >
                      Discount &amp; Biaya Tambahan
                    </p>
                  </v-toolbar-title>
                </v-col>
                <v-col cols="12" md="6" style="padding: 0 4px">
                  <v-text-field
                    v-model="editForm.delivery_costs"
                    dense
                    outlined
                    type="number"
                    min="0"
                    label="Biaya Pengiriman"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" md="6" style="padding: 0 4px">
                  <v-text-field
                    v-model="editForm.service_costs"
                    dense
                    outlined
                    type="number"
                    min="0"
                    label="Biaya Layanan"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" md="6" style="padding: 0 4px">
                  <v-text-field
                    v-model="editForm.other_costs"
                    dense
                    outlined
                    type="number"
                    min="0"
                    label="Biaya Lain-lain"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" md="6" style="padding: 0 4px">
                  <v-text-field
                    v-model="editForm.global_discount_percent"
                    @change="globalPercentWatcher"
                    dense
                    outlined
                    type="number"
                    min="0"
                    label="Diskon Global (%)"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" md="6" style="padding: 0 4px">
                  <v-text-field
                    v-model="editForm.global_discount"
                    @change="globalAmountWatcher"
                    dense
                    outlined
                    type="number"
                    min="0"
                    label="Diskon Global (nominal)"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" md="6" style="padding: 0 4px">
                  <v-text-field
                    v-model="editForm.pph_percent"
                    @change="pphPercentWatcher"
                    dense
                    outlined
                    type="number"
                    min="0"
                    label="PPh (%)"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" md="6" style="padding: 0 4px">
                  <v-text-field
                    v-model="editForm.pph_amount"
                    @change="pphAmountWatcher"
                    dense
                    outlined
                    type="number"
                    min="0"
                    label="PPh (nominal)"
                    style="margin: 0"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              color="error"
              text
              outlined
              type="button"
              @click="editHeaderDialog = false"
              :loading="loading"
            >
              Batal
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              text
              outlined
              type="submit"
              :loading="loading"
            >
              Simpan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- <v-dialog v-model="pdfDialog" width="90%" @click:outside="closePdf">
      <v-card style="position: relative; width: 100%; height: 90vh">
        <v-tooltip bottom>
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              @click.prevent="closePdf"
              v-bind="attrs"
              v-on="on"
              text
              icon
              color="white"
              style="
                position: fixed;
                top: 10px;
                right: 10px;
                z-index: 3;
                filter: drop-shadow(1px 1px 1px white);
              "
            >
              <v-icon color="black">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Close</span>
        </v-tooltip>
        <div
          id="loader"
          class="d-flex justify-center align-center"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        >
          <v-progress-circular
            v-if="isPdfOpen && selectedPdf !== null"
            :rotate="-90"
            :size="150"
            :width="15"
            :value="value"
            color="black"
          >
            {{ value / 10 }}%
          </v-progress-circular>
        </div>
        <div v-if="showPdf" style="height: 100%; padding: 5px 0">
          <v-tooltip bottom>
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                @click.prevent="closePdf"
                v-bind="attrs"
                v-on="on"
                text
                icon
                outlined
                color="white"
                style="position: fixed; top: 10px; right: 10px; z-index: 3"
              >
                <v-icon color="black">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Close</span>
          </v-tooltip>
          <vue-pdf-app
            v-if="selectedPdf !== null"
            @pages-rendered="pagesRendered"
            @open="openHandler"
            :pdf="selectedPdf"
            :file-name="detail.document_no"
          >
            <template #toolbar-sidebar-prepend="{ toggleTheme }">
              <button @click="toggleTheme = null" type="button">
                Toggle theme
              </button>
            </template>
          </vue-pdf-app>

          <div
            v-else
            class="d-flex justify-center align-center"
            style="
              height: 100%;
              width: 100%;
              margin-left: auto;
              position: relative;
              z-index: 1;
              background: #eaeaea;
            "
          >
            <h3 style="margin: 0">File Not Found</h3>
          </div>
        </div>
      </v-card>
    </v-dialog> -->
    <v-dialog
      v-if="detail !== null"
      v-model="dokumenDialog"
      width="500"
      persistent
    >
      <v-card style="position: relative">
        <v-card-title class="text-h5 grey lighten-2">
          Dokumen Pendukung
        </v-card-title>
        <v-card-text class="d-flex justify-center align-center">
          <v-col md="12" style="padding: 0; position: relative; top: 20px">
            <v-data-table
              v-if="detail.file != null"
              mobile-breakpoint="0"
              fixed-header
              height="300"
              style="cursor: pointer"
              :headers="documentHeaders"
              :items="detail.file"
              @click:row="readyToDownload"
              hide-default-footer
            >
              <template v-slot:[`item.subject`]="{ item }">
                <div
                  style="
                    font-size: 12px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  {{
                    item.subject !== null
                      ? item.subject !== ''
                        ? item.subject
                        : '-'
                      : '-'
                  }}
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <div
                  style="
                    font-size: 12px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  <v-btn
                    icon
                    x-small
                    @click.stop="
                      unlinkDokumen(
                        item.file.slice(item.file.lastIndexOf('/') + 1)
                      )
                    "
                    style="margin-right: 5px"
                  >
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                  <v-btn icon x-small @click.stop="readyToDownload(item)">
                    <v-icon color="green">mdi-download</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>

            <v-btn
              elevation="0"
              style="margin-right: auto; width: 100%"
              :loading="loading"
              color="primary"
              @click="uploadDoc('upload')"
            >
              <v-icon small style="margin-right: 5px">mdi-upload</v-icon>
              <span :style="`font-weight: bold; color:white;`"
                >Tambah Dokumen</span
              >
            </v-btn>
          </v-col>
        </v-card-text>
        <!-- <v-btn icon color="black" text @click="closeDokumenDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="error"
            text
            outlined
            @click="closeDokumenDialog"
            :loading="loading"
          >
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            outlined
            :loading="loading"
            @click="deleteAllFile"
          >
            Delete all File
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="rabDialog" width="500" persistent>
      <v-form
        :disabled="loading"
        lazy-validation
        ref="entryFormUpload"
        @submit.prevent="submitUploadDoc"
        style="position: relative"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"> UPLOAD </v-card-title>

          <v-card-text class="d-flex justify-center align-center">
            <v-col md="12" style="padding: 0; position: relative; top: 20px">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Subject
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div>
                    <v-text-field
                      outlined
                      v-model="file_subject"
                      dense
                      :rules="rules.subjectRules"
                    ></v-text-field>
                  </div>
                  <div
                    style="padding: 10px; border: 2px dashed grey; height: 70px"
                  >
                    <v-file-input
                      ref="uploadDoc"
                      placeholder="Pilih File"
                      dense
                      append-icon="mdi-paperclip"
                      prepend-icon=""
                      @change="uploadFileDoc"
                      :rules="rules.docRules"
                    ></v-file-input>
                  </div>
                </v-col>
              </div>
            </v-col>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              id="closeFileUpload"
              color="error"
              text
              outlined
              type="reset"
              @click="uploadDoc('close')"
              :loading="loading"
            >
              close
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              text
              outlined
              type="submit"
              :loading="loading"
              :disabled="fileNameRab === '' || file_subject === ''"
            >
              simpan file
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="selectApprovalDialog" width="500" persistent>
      <v-form
        :disabled="loading"
        ref="selectApprovalForm"
        @submit.prevent="
          detail.status == 0
            ? submitNow()
            : detail.status == 1
            ? fetchMatrix()
            : null
        "
        style="position: relative"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Ingin merubah approval default ?
          </v-card-title>

          <v-card-text class="d-flex justify-center align-center">
            <v-col md="12" style="padding: 0; position: relative; top: 20px">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p style="margin: 0; font-weight: bold">
                    Silahkan pilih approval matrix yang dikehendaki
                  </p>
                  <v-card-subtitle
                    >*kosongkan jika tidak ingin merubah
                    approval</v-card-subtitle
                  >
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div style="height: 45px">
                    <v-autocomplete
                      v-model="approval_matrix_id"
                      :items="dropdownApprovalMatrix"
                      :search-input.sync="approvalSearch"
                      style="margin: 0"
                      label="Pilih Approval"
                      placeholder="kosongkan jika tidak ingin merubah approval"
                      item-text="name"
                      item-value="id"
                      return-id
                      dense
                      hide-details
                      hide-no-data
                      hide-selected
                      clearable
                    ></v-autocomplete>
                  </div>
                </v-col>
              </div>
            </v-col>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              color="error"
              text
              outlined
              @click="closeApprovalDialog"
              :loading="loading"
            >
              Batal
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              type="submit"
              text
              outlined
              :loading="loading"
            >
              Lanjutkan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog
      v-model="warningDialog"
      persistent
      max-width="900px"
      v-if="detail && detail.payment_request"
    >
      <v-card>
        <v-card-title class="text-h5 black--text warning lighten-2">
          <v-icon color="black" style="margin-right: 5px">mdi-alert</v-icon>
          Harap periksa dahulu !!, Dokumen ini berisi data dari CA yang sudah
          direvisi
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" style="border-bottom: 1px solid #eaeaea">
              <p style="margin: 20px 0 0 0; padding: 10px; font-size: 18px">
                Dokumen PJCA ini berisi data dari CA yang sudah direvisi.
                Silahkan periksa kembali rincian item pada PJCA ini dengan
                rincian item pada CA yang terbaru.
                <v-tooltip right color="info">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      @click="openDetailPayreq(detail.payment_request)"
                      style="cursor: pointer"
                      x-small
                      color="primary"
                    >
                      mdi-open-in-new
                    </v-icon>
                  </template>
                  <span>Lihat detail Payreq</span>
                </v-tooltip>
              </p>
              <!-- <p>
                Apabila terdapat perbedaan data antara PJCA dan CA terbaru,
                silahkan lakukan revisi pada PJCA ini agar sesuai dengan CA yang
                terbaru.
              </p> -->
            </v-col>
            <v-col cols="12">
              <div style="padding: 0 10px">
                <v-data-table
                  height="30vh"
                  mobile-breakpoint="0"
                  dense
                  :headers="payreqHeaders"
                  :items="
                    detail.payment_request.payment_request_detail
                      ? detail.payment_request.payment_request_detail
                      : []
                  "
                >
                  <template v-slot:[`item.product_code`]="{ item }">
                    <div
                      class="item-relative"
                      style="width: 95px; font-size: 12px"
                    >
                      {{ item.product_code }}
                      <div v-if="item.status == -1" class="mid-border"></div>
                    </div>
                  </template>
                  <template v-slot:[`item.product_name`]="{ item }">
                    <div class="item-relative">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="on"
                            style="
                              text-align: left;
                              width: 250px;
                              font-size: 12px;
                              padding: 0;
                            "
                          >
                            {{
                              `${
                                item.product_code !== null
                                  ? '(' + item.product_code + ')'
                                  : ''
                              } ${item.product_name}`
                            }}
                          </div>
                        </template>
                        <span>
                          {{
                            `${
                              item.product_code !== null
                                ? '(' + item.product_code + ')'
                                : ''
                            } ${item.product_name}`
                          }}</span
                        >
                      </v-tooltip>
                      <div v-if="item.status == -1" class="mid-border"></div>
                    </div>
                  </template>
                  <template v-slot:[`item.qty_request`]="{ item }">
                    <div style="font-size: 12px" class="item-relative">
                      {{ item.qty_request }}
                      <div v-if="item.status == -1" class="mid-border"></div>
                    </div>
                  </template>
                  <template v-slot:[`item.uom_name`]="{ item }">
                    <div style="font-size: 12px" class="item-relative">
                      {{ item.uom_name }}
                      <div v-if="item.status == -1" class="mid-border"></div>
                    </div>
                  </template>
                  <template v-slot:[`item.price_request`]="{ item }">
                    <div
                      style="width: 105px; font-size: 12px"
                      class="item-relative"
                    >
                      {{ priceConvert(item.price_request) }}
                      <div v-if="item.status == -1" class="mid-border"></div>
                    </div>
                  </template>
                  <template v-slot:[`item.discount_percent`]="{ item }">
                    <div
                      style="width: 75px; font-size: 12px"
                      class="item-relative"
                    >
                      {{ priceConvert(item.discount_percent) }}
                      <div v-if="item.status == -1" class="mid-border"></div>
                    </div>
                  </template>
                  <template v-slot:[`item.discount_amount`]="{ item }">
                    <div
                      style="width: 105px; font-size: 12px"
                      class="item-relative"
                    >
                      {{ priceConvert(item.discount_amount) }}
                      <div v-if="item.status == -1" class="mid-border"></div>
                    </div>
                  </template>
                  <template v-slot:[`item.total_discount`]="{ item }">
                    <div
                      style="width: 105px; font-size: 12px"
                      class="item-relative"
                    >
                      {{ priceConvert(item.total_discount) }}
                      <div v-if="item.status == -1" class="mid-border"></div>
                    </div>
                  </template>
                  <template v-slot:[`item.tax_type`]="{ item }">
                    <div
                      style="width: 105px; font-size: 12px"
                      class="item-relative"
                    >
                      <v-chip
                        x-small
                        color="grey"
                        v-if="
                          dropdown.tax.find(({ id }) => id == item.tax_type) !=
                          undefined
                        "
                        style="font-size: 10px; font-weight: bold"
                      >
                        {{
                          dropdown.tax.find(({ id }) => id == item.tax_type)
                            .name
                        }}
                      </v-chip>
                      <span v-else></span>
                      <div v-if="item.status == -1" class="mid-border"></div>
                    </div>
                  </template>
                  <template v-slot:[`item.item_type`]="{ item }">
                    <div style="font-size: 12px" class="item-relative">
                      <v-chip
                        x-small
                        color="grey"
                        style="font-size: 10px; font-weight: bold"
                      >
                        {{
                          item.item_type == 1
                            ? 'Original'
                            : item.item_type == 2
                            ? 'Revisi'
                            : '-'
                        }}
                      </v-chip>
                      <div v-if="item.status == -1" class="mid-border"></div>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions style="position: relative">
          <v-btn color="primary" outlined type="button" @click="confirmPjca">
            Ya, Tetap Lanjutkan
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="warningDialog = false">
            <v-icon small>mdi-close</v-icon> BATAL
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div style="position: absolute; right: 15px; top: 1px" class="d-flex">
      <h6
        class="mr-2"
        style="
          text-align: right;
          border: 1px solid rgba(0, 0, 0, 0.3);
          border-radius: 5px;
          cursor: pointer;
        "
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              icon
              small
              @click="previousPage"
              v-bind="attrs"
              v-on="on"
              :disabled="
                Number($route.query.idx) === 0 || $route.query.idx === undefined
              "
            >
              <v-icon style="position: relative; top: -1px; right: 0"
                >mdi-chevron-left</v-icon
              >
            </v-btn>
          </template>
          <span>previous</span>
        </v-tooltip>
      </h6>
      <p style="margin: 0; position: relative; top: 3px">
        <span>
          {{
            $route.query.idx !== undefined ? Number($route.query.idx) + 1 : '1'
          }}
        </span>
        /
        <span v-if="$route.params.path != 'notification'">
          <span v-if="getPjcaList.list != null">
            {{ $route.query.idx !== undefined ? getPjcaList.list.length : '1' }}
          </span>
        </span>
        <span v-else>
          <span v-if="getNotificationQueue.list != null">
            {{
              $route.query.idx !== undefined
                ? getNotificationQueue.list.length
                : '1'
            }}
          </span>
        </span>
      </p>
      <h6
        class="ml-2"
        style="
          text-align: right;
          border: 1px solid rgba(0, 0, 0, 0.3);
          border-radius: 5px;
          cursor: pointer;
        "
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              v-if="$route.query.idx === undefined"
              icon
              small
              @click="nextPage"
              v-bind="attrs"
              v-on="on"
              disabled
            >
              <v-icon style="position: relative; top: -1px; right: 0"
                >mdi-chevron-right</v-icon
              >
            </v-btn>
            <div v-else>
              <div v-if="$route.params.path != 'notification'">
                <v-btn
                  v-if="getPjcaList.list != null"
                  icon
                  small
                  @click="nextPage"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="
                    Number($route.query.idx) === getPjcaList.list.length - 1
                  "
                >
                  <v-icon style="position: relative; top: -1px; right: 0"
                    >mdi-chevron-right</v-icon
                  >
                </v-btn>
              </div>
              <div v-else>
                <v-btn
                  v-if="getNotificationQueue.list != null"
                  icon
                  small
                  @click="nextPage"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="
                    Number($route.query.idx) ===
                    getNotificationQueue.list.length - 1
                  "
                >
                  <v-icon style="position: relative; top: -1px; right: 0"
                    >mdi-chevron-right</v-icon
                  >
                </v-btn>
              </div>
            </div>
          </template>
          <span>next</span>
        </v-tooltip>
      </h6>
    </div>
    <div
      v-if="loading"
      class="d-flex justify-center align-center"
      style="
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 5;
        background: rgba(0, 0, 0, 0.1);
      "
    >
      <v-progress-circular
        :size="100"
        color="primary"
        indeterminate
        class="d-flex justify-center align-center"
      >
        <p
          class="d-flex justify-center align-center"
          style="font-size: 12px; margin: auto"
        >
          Please wait
        </p>
      </v-progress-circular>
    </div>
  </v-container>
</template>
<script>
import 'vue-pdf-app/dist/icons/main.css'
import axios from 'axios'
import buildType from '../../../services/buildType'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { globalMixin } from '../../../mixin/globalMixin'
import moment from 'moment'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  components: {
    FormItemPjca: () => import('./ItemForm')
  },
  mixins: [globalMixin],
  data() {
    return {
      pageKey: 0,
      config: require('../../../services/config.json')[env],
      wWidth: window.innerWidth,
      oAuth: buildType.apiURL('oauth'),
      proc: buildType.apiURL('proc'),
      hrsApi: buildType.apiURL('hrs'),
      upload: buildType.apiURL('upload2'),
      isLoadingPage: true,
      pagePath: this.$route.params.path,
      userLevel: null,
      permission: null,
      isEdit: false,
      editHeaderDialog: false,
      editForm: {
        to_department: null,
        vendor_name: null,
        bank_name: null,
        account_number: null,
        account_name: null,
        delivery_costs: null,
        service_costs: null,
        other_costs: null,
        global_discount_percent: null,
        global_discount: null,
        pph_percent: null,
        pph_amount: null
      },
      pdfDialog: false,
      dokumenDialog: false,
      closeDialog: false,
      rabDialog: false,

      checkbox: false,
      detail: null,
      // payreqDetail: null,
      searchItem: '',
      itemsAction: [],
      status: null,
      actionValue: 0,
      selectedData: [],
      loading: false,
      loader: null,
      fileNameRab: '',

      itemEdit: null,

      isAllow: false,
      matrix: [],
      rules: {},
      snackbar: false,
      alertText: '',
      timeout: 2000,
      value: 0,
      counter: 0,
      timer: 100,
      isPdfOpen: false,
      selectedPdf: null,
      showPdf: false,
      file_subject: '',

      selectedItem: null,
      options: {},
      tab: null,
      items: [
        { tab: 'Detail Barang', content: '' },
        { tab: 'Approval', content: '' }
      ],
      act: 'add',
      itemDetail: null,
      pjcaList: [],
      dropdown: {
        vendor: [],
        tax: [
          {
            id: 6,
            name: 'PPn 12% Inc'
          },
          {
            id: 7,
            name: 'PPn 12% Exc'
          }
          // {
          //   id: 5,
          //   name: 'PPh 22 (0,3%)'
          // }
        ]
      },
      isFinance: false,
      isHeadFinance: false,
      approval_matrix_id: null,
      dropdownApprovalMatrix: [],
      approvalSearch: null,
      approvalSelect: null,
      selectApprovalDialog: false,
      warningDialog: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  computed: {
    ...mapGetters([
      'getUserProfile',
      'getPjcaList',
      'getTabs',
      'getNotificationQueue'
    ]),
    pjcaHeaders() {
      const arrHeaders = [
        {
          text: 'No',
          value: 'no',
          align: 'left'
          // sortable: true,
        },
        {
          text: 'Kode Barang',
          value: 'product_code',
          align: 'left'
          // sortable: false,
        },
        {
          text: 'Nama Barang',
          value: 'product_name',
          align: 'left'
          // sortable: false,
        },
        {
          text: 'Qty Rilis',
          value: 'qty_done',
          align: 'left',
          // sortable: true,
          sortable: false
        },
        {
          text: 'Satuan',
          value: 'uom_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Diskon (%)',
          value: 'discount_percent',
          align: 'left',
          // sortable: true,
          sortable: false
        },
        {
          text: 'Diskon (num)',
          value: 'discount_amount',
          align: 'left',
          // sortable: true,
          sortable: false
        },
        // {
        //   text: 'Harga Sebelum',
        //   value: 'price_request',
        //   align: 'left'
        //   // sortable: false,
        // },
        {
          text: 'Harga Rilis',
          value: 'price_done',
          align: 'left'
          // sortable: false,
        },
        {
          text: 'Total Diskon',
          value: 'total_discount',
          align: 'left',
          // sortable: true,
          sortable: false
        },
        {
          text: 'Pajak',
          value: 'tax_type',
          align: 'left',
          // sortable: true,
          sortable: false
        },
        {
          text: 'Subtotal',
          value: 'subtotal',
          align: 'left',
          sortable: false
        },
        {
          text: 'Link',
          value: 'purchase_request_detail',
          align: 'left',
          sortable: false
        }
      ]
      // if (this.detail.status.id === 0) {
      return arrHeaders
      // }
    },
    approvalHeaders() {
      const arrHeaders = [
        { text: 'Sequence', value: 'sequence', align: 'left' },
        { text: 'Doc. No', value: 'document_no', align: 'left' },
        { text: 'Model', value: 'table_name', align: 'center' },
        { text: 'User', value: 'approver_user', align: 'center' },
        {
          text: 'Min. Approver',
          value: 'min_approver',
          align: 'center'
        },
        {
          text: 'Approved by',
          value: 'approved',
          align: 'center'
        },
        {
          text: 'Rejected by',
          value: 'rejected',
          align: 'center'
        },
        {
          text: 'Created at',
          value: 'created_at',
          align: 'center'
        },
        {
          text: 'Update at',
          value: 'updated_at',
          align: 'center'
        }
      ]
      return arrHeaders
    },
    documentHeaders() {
      return [
        {
          text: 'File Name',
          value: 'subject',
          align: 'left',
          sortable: false,
          width: '90%'
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false,
          width: '10%'
        }
      ]
    },
    payreqHeaders() {
      const arrHeaders = [
        {
          text: 'Kode Barang',
          value: 'product_code',
          align: 'left'
          // sortable: false,
        },
        {
          text: 'Nama Barang',
          value: 'product_name',
          align: 'left'
          // sortable: false,
        },
        {
          text: 'Qty',
          value: 'qty_request',
          align: 'left',
          // sortable: true,
          sortable: false
        },
        {
          text: 'Unit',
          value: 'uom_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Diskon (%)',
          value: 'discount_percent',
          align: 'left',
          // sortable: true,
          sortable: false
        },
        {
          text: 'Diskon (nom)',
          value: 'discount_amount',
          align: 'left',
          // sortable: true,
          sortable: false
        },
        {
          text: 'Harga/unit',
          value: 'price_request',
          align: 'left',
          sortable: false
        },
        {
          text: 'Total Diskon',
          value: 'total_discount',
          align: 'left',
          // sortable: true,
          sortable: false
        },
        {
          text: 'Pajak',
          value: 'tax_type',
          align: 'center',
          // sortable: true,
          sortable: false
        },
        {
          text: 'Tipe',
          value: 'item_type',
          align: 'left',
          // sortable: true,
          sortable: false
        }
      ]
      return arrHeaders
    }
  },
  watch: {
    selectedData() {
      this.itemsAction = [
        { id: 0, name: '' },
        { id: 1, name: 'Delete' }
      ]
      if (this.detail.status == 0 || this.detail.status == 2) {
        this.itemsAction.push({ id: 3, name: 'Edit Link' })
      }
    },
    approvalSearch(val) {
      if (val !== null) {
        if (val !== '') {
          val &&
            val !== this.approvalSelect &&
            this.getApprovalMatrixDropdown(val)
        } else {
          this.approvalSelect = null
          this.dropdownApprovalMatrix = []
        }
      } else {
        this.approvalSelect = null
        this.dropdownApprovalMatrix = []
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
    this.appLevel = this.config.application.ecatalogue.userLevel
    this.appLevel.administrator =
      this.config.application.all.userLevel.administrator
    this.isFinance =
      this.getUserProfile.level.find(
        ({ id }) =>
          id == this.appLevel.faChecker || id == this.appLevel.faPayment
      ) != undefined

    this.getDataMenu()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'menu_access',
      'getMenuId',
      'openNotification',
      'changeToRead'
    ]),
    customSearch(value, search, item) {
      return Object.values(item).some(
        (v) => v && v.toString().toLowerCase().includes(search)
      )
    },
    showMsgDialog(
      pModalType,
      pStatusMsg,
      pBtnCancel,
      pInputType,
      pInputAtt,
      yesBtn,
      noBtn,
      pText
    ) {
      const title =
        pInputType === 'file'
          ? 'Upload bukti approvement pada kolom dibawah'
          : 'Tolong isi alasan pada kolom dibawah sebelum submit'

      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>' +
              '<br/>' +
              additional,
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            input: pInputType !== undefined ? pInputType : null,
            inputLabel: pInputType !== undefined ? title : null,
            // inputAttributes: pInputAtt !== undefined ? pInputAtt : null,
            confirmButtonText: yesBtn || 'Yes',
            cancelButtonText: noBtn || 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    deliveryCostWathcer(val) {
      console.log(val)
    },
    globalAmountWatcher() {
      let d = this.detail
      if (this.editHeaderDialog) {
        d = this.editForm
      }
      if (d != null) {
        d.global_discount_percent = 0
        if (d.global_discount == '') {
          d.global_discount = 0
        }
      }
      return 0
    },
    globalPercentWatcher() {
      let d = this.detail
      if (this.editHeaderDialog) {
        d = this.editForm
      }
      if (d != null) {
        d.global_discount = 0
        if (d.global_discount_percent == '') {
          d.global_discount_percent = 0
        }
      }
      return 0
    },
    pphAmountWatcher() {
      let d = this.detail
      if (this.editHeaderDialog) {
        d = this.editForm
      }
      if (d != null) {
        d.pph_percent = 0
        if (d.pph_amount == '') {
          d.pph_amount = 0
        }
      }
      return 0
    },
    pphPercentWatcher() {
      let d = this.detail
      if (this.editHeaderDialog) {
        d = this.editForm
      }
      if (d != null) {
        d.pph_amount = 0
        if (d.pph_percent == '') {
          d.pph_percent = 0
        }
      }
      return 0
    },
    async getDataMenu() {
      this.isLoadingPage = true
      const split = this.$route.path.split('/')
      let routeModule = ''
      if (this.$route.params.path != 'notification') {
        routeModule = '/' + split[1] + '/' + split[2]
      } else {
        routeModule = '/' + split[1] + '/' + split[3]
      }
      console.log('Path>>>>>', routeModule)
      await this.getMenuId({
        keyword: '',
        path: routeModule
      })
        .then((result) => {
          if (result.data.status_code === '00') {
            const menuId = result.data.data[0].id
            this.userLevel = this.getUserProfile.level.find(
              ({ application }) =>
                application.id === this.config.application.all.applicationId ||
                application.id ===
                  this.config.application.ecatalogue.applicationId
            )
            if (this.userLevel !== null) {
              this.checkMenuAccess([menuId, this.userLevel.id])
            } else {
              this.resetPermission(null)
            }
          } else {
            this.isLoadingPage = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.isLoadingPage = false
        })
    },
    async checkMenuAccess(payload) {
      await this.menu_access(payload)
        .then((result) => {
          console.log('menuAccess>>>>', result)
          this.resetPermission(result)
        })
        .catch((err) => {
          console.log(err)
          this.resetPermission(null)
        })
    },
    resetPermission(val) {
      this.permission = null

      if (val !== null) {
        if (val.data !== null) {
          if (val.data.read_perm === 1) {
            this.permission = val.data
            this.initDataForLayout()
          }
        }
      }
      this.isLoadingPage = false
    },
    initDataForLayout() {
      this.isEdit = false

      this.loadPage()
    },
    nextPage() {
      this.loading = true
      try {
        const pageIndex = Number(this.$route.query.idx) + 1
        if (this.$route.params.path != 'notification') {
          const xData = this.getPjcaList.list[pageIndex]
          const path = `/e-catalogue/pjca/detail/${xData.id}?idx=${pageIndex}`
          if (this.$route.path !== path) this.$router.push(path)
          setTimeout(() => {
            this.loadPage()
          }, 200)
        } else {
          const xData = this.getNotificationQueue.list[pageIndex]
          if (xData.module === 'pjca') {
            // this.$store.commit('setFpbId', pItem.document_id)
            const path = `/e-catalogue/notification/pjca/detail/${xData.document_id}?idx=${pageIndex}`
            if (this.$route.path !== path) this.$router.push(path)
            setTimeout(() => {
              this.changeToRead(xData)
              this.loadPage()
            }, 200)
            return null
          } else {
            this.openNotification({ data: xData, idx: pageIndex })
          }
        }
      } catch (e) {
        this.loading = false
      }
    },
    previousPage() {
      this.loading = true
      try {
        const pageIndex = Number(this.$route.query.idx) - 1
        if (this.$route.params.path != 'notification') {
          const xData = this.getPjcaList.list[pageIndex]
          const path = `/e-catalogue/pjca/detail/${xData.id}?idx=${pageIndex}`
          if (this.$route.path !== path) this.$router.push(path)
          setTimeout(() => {
            this.loadPage()
          }, 200)
        } else {
          const xData = this.getNotificationQueue.list[pageIndex]
          if (xData.module === 'pjca') {
            // this.$store.commit('setFpbId', pItem.document_id)
            const path = `/e-catalogue/notification/pjca/detail/${xData.document_id}?idx=${pageIndex}`
            if (this.$route.path !== path) this.$router.push(path)
            setTimeout(() => {
              this.changeToRead(xData)
              this.loadPage()
            }, 200)
            return null
          } else {
            this.openNotification({ data: xData, idx: pageIndex })
          }
        }
      } catch (e) {
        this.loading = false
      }
    },
    async loadPage() {
      this.loading = true
      const url = `${this.proc}pjca/detail/${this.$route.params.id}`
      await axios
        .get(url)
        .then((res) => {
          console.log('Detaill >>>', res)
          if (res.data.status_code == '00') {
            // this.getDetailPayreq(res.data.data)
            res.data.data.received_date = moment(
              res.data.data.received_date
            ).format('YYYY-MM-DD')
            this.detail = res.data.data
            if (res.data.data.status == 1) {
              this.authorityCheck(res.data.data)
            }
            // this.dropdownDepartment()
            // this.dropdownShift()
            if (
              res.data.data.approval_matrix != null &&
              res.data.data.approval_matrix.length > 0
            ) {
              const ax =
                res.data.data.approval_matrix[
                  res.data.data.approval_matrix.length - 1
                ]
              const xFindEmail = ax.approver_user.find(
                ({ user }) => user.email == this.getUserProfile.employee.email
              )
              if (xFindEmail != undefined) {
                this.isHeadFinance = true
              }
            }
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
          }
          this.loading = false
          return null
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          this.loading = false
          return null
        })
    },
    // async getDetailPayreq(xData) {
    //   this.loading = true
    //   const url = `${this.proc}payreq/detail/${xData.payment_request.id}`
    //   await axios
    //     .get(url)
    //     .then((res) => {
    //       console.log('Detaill payreq >>>', res)
    //       if (res.data.status_code == '00') {
    //         this.payreqDetail = res.data.data
    //       }
    //       this.loading = false
    //       return null
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //       this.loading = false
    //       return null
    //     })
    // },
    async saveChange() {
      // apply dialog form back to detail before validation/save
      if (this.editForm) {
        if (this.editForm.to_department_id) {
          const dep = this.dropdown.department.find(
            (e) => e.id == this.editForm.to_department_id
          )
          this.detail.to_department = dep || null
          this.detail.to_department_id = this.editForm.to_department_id
          this.detail.to_department_name = dep ? dep.name : null
        }
        this.detail.vendor_name = this.editForm.vendor_name
        this.detail.bank_name = this.editForm.bank_name
        this.detail.account_number = this.editForm.account_number
        this.detail.account_name = this.editForm.account_name
        this.detail.delivery_costs = this.editForm.delivery_costs
        this.detail.service_costs = this.editForm.service_costs
        this.detail.other_costs = this.editForm.other_costs
        this.detail.global_discount_percent =
          this.editForm.global_discount_percent
        this.detail.global_discount = this.editForm.global_discount
        this.detail.pph_percent = this.editForm.pph_percent
        this.detail.pph_amount = this.editForm.pph_amount
      }
      this.showMsgDialog('question', 'Simpan Perubahan', true).then(
        async (res) => {
          if (res.isConfirmed) {
            this.loading = true
            const form = {
              act: 'update',
              id: this.$route.params.id,
              to_department_id: this.detail.to_department.id,
              to_department_name: this.detail.to_department.name,
              global_discount: this.detail.global_discount,
              global_discount_percent: this.detail.global_discount_percent,
              delivery_costs: this.detail.delivery_costs,
              service_costs: this.detail.service_costs,
              other_costs: this.detail.other_costs,
              account_name: this.detail.account_name,
              account_number: this.detail.account_number,
              bank_name: this.detail.bank_name,
              pph_amount: this.detail.pph_amount,
              pph_percent: this.detail.pph_percent,
              vendor_name: this.detail.vendor_name
              // tax: this.detail.tax
            }

            await axios
              .post(`${this.proc}pjca/save`, form)
              .then((res) => {
                console.log(res.data)
                this.loading = false
                if (res.data.status_code == '00') {
                  this.editHeaderDialog = false
                  this.loadPage()
                  this.showMsgDialog('success', res.data.status_msg, false)
                } else {
                  if (res.data.status_msg === 'Parameter value has problem') {
                    this.showMsgDialog(
                      'warning',
                      'Invalid input, Parameter value has problem',
                      false
                    )
                  } else {
                    this.showMsgDialog('warning', res.data.status_msg, false)
                  }
                }
                this.isEdit = false
              })
              .catch((err) => {
                console.log(err)
                this.loading = false
                this.isEdit = false
                this.showMsgDialog(
                  'error',
                  err
                    ? 'Something went wrong, Please contact an admin!'
                    : 'Something went wrong, Please contact an admin!',
                  false
                )
              })
          }
        }
      )
    },
    openDetailPayreq(xData) {
      if (xData != null) {
        // const arrItem = {
        //   list: []
        // }
        // this.$store.commit('setFpbList', arrItem)
        setTimeout(() => {
          window.open(`/e-catalogue/payreq/detail/${xData.id}?idx=0`, '_blank')
        }, 200)
      }
    },
    openItemForm() {
      this.act = 'add'
      setTimeout(() => {
        document.getElementById('pjcaItemForm').click()
      }, 300)
    },
    // initDropdown() {
    //   this.dropdownUnit()
    // },

    closePage() {
      this.detail = null
      const split = this.$route.path.split('/')
      const routeModule = '/' + split[1] + '/' + split[2]
      // this.$store.commit('setFpbId', null)
      // this.$router.push('/e-catalogue/' + this.$route.params.path)
      if (this.prevRoute !== undefined) {
        // if (this.prevRoute.path !== '/e-catalogue/cart') {
        // this.$router.push(this.prevRoute.path)
        // } else {
        this.$router.push(routeModule)
        // }
      } else {
        this.$router.push(routeModule)
      }
    },
    rowClick(pValue) {
      this.act = 'update'
      this.itemDetail = pValue
      setTimeout(() => {
        document.getElementById('pjcaItemForm').click()
      }, 300)
    },
    editDetail() {
      this.getDropdownDepartment()
      this.editForm = {
        to_department_id: this.detail.to_department_id,
        vendor_name: this.detail.vendor_name,
        bank_name: this.detail.bank_name,
        account_number: this.detail.account_number,
        account_name: this.detail.account_name,
        delivery_costs: this.detail.delivery_costs,
        service_costs: this.detail.service_costs,
        other_costs: this.detail.other_costs,
        global_discount_percent: this.detail.global_discount_percent,
        global_discount: this.detail.global_discount,
        pph_percent: this.detail.pph_percent,
        pph_amount: this.detail.pph_amount
      }
      this.editHeaderDialog = true
    },
    async getDropdownDepartment() {
      await axios
        .get(
          `${this.hrsApi}master/universal/department/dropdown?filter=[{"company_id":${this.detail.company_id}}]`
        )
        .then((res) => {
          console.log(res)
          if (res.data.status_code === '00') {
            return (this.dropdown.department = res.data.data)
          }
          return (this.dropdown.department = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.department = [])
        })
    },
    submitPjca() {
      if (
        Math.abs(
          this.detail.total_price - this.detail.payment_request.total_price
        ) > 0
      ) {
        if (
          this.detail.account_name == null ||
          this.detail.account_name == '' ||
          this.detail.account_number == null ||
          this.detail.account_number == '' ||
          this.detail.bank_name == null ||
          this.detail.bank_name == ''
        ) {
          this.showMsgDialog(
            'warning',
            'Ada selisih dana, Tuliskan informasi rekening untuk transfer selisihnya dahulu',
            false
          )
          return
        }
      }

      this.showMsgDialog(
        'warning',
        'Data tidak dapat dirubah bila sudah disubmit, lanjutkan ?',
        true,
        undefined,
        undefined,
        'Submit',
        'Batal',
        ''
      ).then(async (res) => {
        if (res.isConfirmed) {
          if (
            (this.detail.status.id == 0 || this.detail.status.id == 1) &&
            this.getUserProfile != null &&
            this.getUserProfile.employee != null &&
            this.getUserProfile.employee.department != null &&
            (this.getUserProfile.employee.department.id == 2 ||
              this.getUserProfile.employee.department.id == 3 ||
              this.getUserProfile.employee.department.id == 9 ||
              this.getUserProfile.employee.department.id == 59)
          ) {
            this.getApprovalMatrixDropdown('')
            setTimeout(() => {
              this.selectApprovalDialog = true
            }, 300)
          } else {
            this.submitNow()
          }
        }
      })
    },
    submitNow() {
      this.loading = true
      axios
        .post(`${this.proc}pjca/submit`, {
          id: this.detail.id,
          approval_matrix_id: this.approval_matrix_id
        })
        .then(async (res) => {
          this.loading = false
          if (res.data.status_code == '00') {
            this.showMsgDialog('success', res.data.status_msg, false)

            if (this.detail.approval_matrix !== null) {
              await this.fetchMatrix()
              // console.log('fetch done')
            } else {
              this.loadPage()
            }
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
          this.selectApprovalDialog = false
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          this.selectApprovalDialog = false
        })
    },
    validateBeforeConfirm() {
      if (
        this.detail.pjca_detail.find(
          ({ payment_request_detail }) =>
            payment_request_detail && payment_request_detail.item_type == 2
        ) != undefined
      ) {
        this.warningDialog = true
      } else {
        this.confirmPjca()
      }
    },
    confirmPjca() {
      this.showMsgDialog(
        'question',
        'Confirm PJCA Sekarang ?',
        true,
        undefined,
        undefined,
        'Confirm',
        'Batal',
        ''
      ).then((res) => {
        if (res.isConfirmed) {
          this.warningDialog = false
          this.loading = true
          const document_id = this.detail.approval_matrix[0].document_id
          axios
            .post(`${this.proc}pjca/confirm`, {
              document_id: document_id
            })
            .then((res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                this.loadPage()
                this.showMsgDialog('success', res.data.status_msg, false)
              } else {
                if (res.data.status_msg === 'Parameter value has problem') {
                  this.showMsgDialog(
                    'warning',
                    'Invalid input, Parameter value has problem',
                    false
                  )
                } else {
                  this.showMsgDialog('warning', res.data.status_msg, false)
                }
              }
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    rejectPjca() {
      this.showMsgDialog(
        'question',
        'Reject PJCA ?',
        true,
        'textarea',
        undefined,
        'Reject',
        'Batal',
        ''
      ).then((res) => {
        if (res.isConfirmed) {
          if (res.value != '') {
            this.loading = true
            const date = new Date()
            const local = date.toLocaleString('id')
            const updateAt = `[${local} - ${this.getUserProfile.employee.name}]\n${res.value}`
            // const document_id = this.detail.approval_matrix[0].document_id
            axios
              .post(`${this.proc}pjca/reject`, {
                document_id: this.detail.id,
                reject_reason: updateAt
              })
              .then((res) => {
                this.loading = false

                if (res.data.status_code == '00') {
                  this.loadPage()
                  this.showMsgDialog('success', res.data.status_msg, false)
                } else {
                  if (res.data.status_msg === 'Parameter value has problem') {
                    this.showMsgDialog(
                      'warning',
                      'Invalid input, Parameter value has problem',
                      false
                    )
                  } else {
                    this.showMsgDialog('warning', res.data.status_msg, false)
                  }
                }
              })
              .catch((err) => {
                this.loading = false
                this.showMsgDialog(
                  'error',
                  err
                    ? 'Something went wrong, Please contact an admin!'
                    : 'Something went wrong, Please contact an admin!',
                  false
                )
              })
          } else {
            this.showMsgDialog(
              'warning',
              'Kolom alasan tidak boleh kosong',
              false
            )
          }
        }
      })
    },
    cancelPjca() {
      this.showMsgDialog(
        'question',
        'Cancel PJCA ?',
        true,
        'textarea',
        undefined,
        'Cancel',
        'Batal',
        ''
      ).then((res) => {
        if (res.isConfirmed) {
          if (res.value != '') {
            this.loading = true
            const date = new Date()
            const local = date.toLocaleString('id')
            const updateAt = `[${local} - ${this.getUserProfile.employee.name}]\n${res.value}`
            // const document_id = this.detail.approval_matrix[0].document_id
            axios
              .post(`${this.proc}pjca/cancel`, {
                id: this.detail.id,
                cancel_reason: updateAt
              })
              .then((res) => {
                this.loading = false

                if (res.data.status_code == '00') {
                  this.loadPage()
                  this.showMsgDialog('success', res.data.status_msg, false)
                } else {
                  if (res.data.status_msg === 'Parameter value has problem') {
                    this.showMsgDialog(
                      'warning',
                      'Invalid input, Parameter value has problem',
                      false
                    )
                  } else {
                    this.showMsgDialog('warning', res.data.status_msg, false)
                  }
                }
              })
              .catch((err) => {
                this.loading = false
                this.showMsgDialog(
                  'error',
                  err
                    ? 'Something went wrong, Please contact an admin!'
                    : 'Something went wrong, Please contact an admin!',
                  false
                )
              })
          } else {
            this.showMsgDialog(
              'warning',
              'Kolom alasan tidak boleh kosong',
              false
            )
          }
        }
      })
    },
    setDraftPjca() {
      this.showMsgDialog(
        'question',
        'Set to draft dokumen ?',
        true,
        undefined,
        undefined,
        'Simpan',
        'Batal',
        ''
      ).then((res) => {
        if (res.isConfirmed) {
          this.loading = true
          // const document_id = this.detail.approval_matrix[0].document_id
          axios
            .post(`${this.proc}pjca/set_to_draft`, {
              id: this.detail.id
            })
            .then((res) => {
              this.loading = false

              if (res.data.status_code == '00') {
                this.loadPage()
                this.showMsgDialog('success', res.data.status_msg, false)
              } else {
                if (res.data.status_msg === 'Parameter value has problem') {
                  this.showMsgDialog(
                    'warning',
                    'Invalid input, Parameter value has problem',
                    false
                  )
                } else {
                  this.showMsgDialog('warning', res.data.status_msg, false)
                }
              }
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    donePjca() {
      this.showMsgDialog(
        'question',
        'Selesaikan dokumen ini ?',
        true,
        undefined,
        undefined,
        'Ya',
        'Batal',
        ''
      ).then((res) => {
        if (res.isConfirmed) {
          this.loading = true
          // const document_id = this.detail.approval_matrix[0].document_id
          axios
            .post(`${this.proc}pjca/done`, {
              id: this.detail.id
            })
            .then((res) => {
              this.loading = false

              if (res.data.status_code == '00') {
                this.loadPage()
                this.showMsgDialog('success', res.data.status_msg, false)
              } else {
                if (res.data.status_msg === 'Parameter value has problem') {
                  this.showMsgDialog(
                    'warning',
                    'Invalid input, Parameter value has problem',
                    false
                  )
                } else {
                  this.showMsgDialog('warning', res.data.status_msg, false)
                }
              }
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    itemDelete(item, index) {
      console.log('this.selectedData', this.selectedData)
      this.showMsgDialog(
        'question',
        'Item tersebut akan dihapus, Anda yakin ?',
        true
      ).then((res) => {
        if (res.isConfirmed) {
          for (let i = 0; i < this.selectedData.length; i++) {
            axios
              .delete(
                `${this.proc}pjca/delete_detail/${this.selectedData[i].id}`
              )
              .then((res) => {
                console.log('delete>>>>', res)
                if (i === this.selectedData.length - 1) {
                  if (res.data.status_code === '00') {
                    this.showMsgDialog('success', res.data.status_msg, false)
                  } else {
                    this.showMsgDialog('error', res.data.status_msg, false)
                  }
                  setTimeout(() => {
                    this.actionValue = 0
                    this.loadPage()
                  }, 200)
                }
              })
              .catch((err) => {
                if (i === this.selectedData.length - 1) {
                  this.showMsgDialog('error', err.message, false)
                  setTimeout(() => {
                    this.actionValue = 0
                  }, 200)
                }
              })
          }
        } else {
          this.actionValue = 0
        }
      })
    },
    authorityCheck(item) {
      if (item.approval_matrix !== null) {
        const matrixId = item.approval_matrix[0].document_id
        axios
          .get(
            `${this.oAuth}approval_matrix/document/allow_user?document_id=${matrixId}&application_id=8&table_name=tr_pjcas`
          )
          .then((res) => {
            if (res.data.status_code !== '-99') {
              if (res.data.is_allow_approve !== 0) {
                this.isAllow = true
              } else {
                this.isAllow = false
              }
            } else {
              this.isAllow = false
            }
          })
          .catch((err) => {
            this.showMsgDialog(
              'error',
              err
                ? 'Cek Otoritas error, Silahkan info ke Admin'
                : 'Cek Otoritas error, Silahkan info ke Admin',
              false
            )
          })
      }
    },
    async fetchMatrix() {
      this.loading = true
      const form = {
        id: this.detail.id,
        approval_matrix_id: this.approval_matrix_id
      }
      await axios
        .post(`${this.proc}pjca/fetch_matrix`, form)
        .then(async (res) => {
          if (res.data.status_code == '00') {
            if (res.data.approval_matrix_result.status_code == '00') {
            } else {
              this.showMsgDialog(
                'warning',
                res.data.approval_matrix_result.status_msg,
                false
              )
            }
            this.loadPage()
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
          }
          this.loading = false
          this.closeApprovalDialog()
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          this.closeApprovalDialog()
        })
    },
    actionSelect(event) {
      switch (event) {
        case 1:
          this.itemDelete()
          break
        case 3:
          this.editStoreLink()
          break
      }
    },
    statusName(val) {
      const arrType = ['DRAFT', 'WAITING APPROVAL', 'DONE', 'CANCEL', 'REJECT']
      return arrType[val]
    },
    statusColor(val) {
      const arrType = ['grey', 'orange', 'green', 'red', 'red']
      return arrType[val]
    },
    convertDate(val) {
      const raw = val
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      }
    },
    // priceConvert(xVal) {
    //   const num = 0
    //   let digitVal = 3
    //   if (this.digitAfterComa != null && this.digitAfterComa > 0) {
    //     digitVal = this.digitAfterComa
    //   }
    //   if (xVal != undefined) {
    //     if (xVal != null) {
    //       let round = xVal
    //       if (round.toString().includes('.')) {
    //         round = parseFloat(round).toFixed(digitVal)
    //       }
    //       const val = round + ''
    //       let result = ''

    //       if (val.includes('.')) {
    //         const splitVal = val.split('.')
    //         const main = splitVal[0]
    //         const decimal = splitVal[1]
    //         result =
    //           main.toString().replace(/\B(?<!\\d*)(?=(\d{3})+(?!\d))/g, ',') +
    //           `.${decimal}`
    //       } else {
    //         result = val
    //           .toString()
    //           .replace(/\B(?<!\\d*)(?=(\d{3})+(?!\d))/g, ',')
    //       }
    //       return result
    //     }
    //   }
    //   return num
    // },
    generatePdfPjca() {
      this.generatePDF(
        `${this.proc}pjca/export_to_pdf/${this.$route.params.id}`,
        axios
      )
      // this.loader = 'loading'

      // const l = this.loader
      // this[l] = !this[l]
      // setTimeout(() => {
      //   this[l] = false
      //   axios({
      //     url: `${this.proc}pjca/export_to_pdf/${this.$route.params.id}`,
      //     method: 'GET',
      //     // responseType: 'arraybuffer'
      //     responseType: 'blob'
      //   })
      //     .then((res) => {
      //       this.selectedPdf = res.data
      //       // setTimeout(() => {
      //       //   this.viewPDF()
      //       // }, 1000)
      //       const url = URL.createObjectURL(res.data)
      //       window.open(url, '_blank')
      //     })
      //     .catch((error) => {
      //       console.log(error)
      //     })
      // }, 2000)

      // this.loader = null
    },
    // viewPDF() {
    //   if (!this.isPdfOpen) {
    //     this.pdfDialog = true
    //     this.isPdfOpen = true
    //     // this.selectedPdf = 'true'
    //     // this.selectedPdf = pItem.file
    //     this.countDownTimer()
    //   }
    // },
    // countDownTimer() {
    //   if (this.counter < this.timer) {
    //     setTimeout(() => {
    //       this.counter += 1
    //       this.value += 10
    //       this.countDownTimer()
    //     }, 1)
    //   } else {
    //     this.showPdf = true
    //     this.value = 0
    //     this.counter = 0
    //   }
    // },
    // async openHandler(pdfApp) {
    //   this.info = []
    //   const info = await pdfApp.pdfDocument
    //     .getMetadata()
    //     .catch(console.error.bind(console))

    //   if (!info) return
    //   const props = Object.keys(info.info)
    //   props.forEach((prop) => {
    //     const obj = {
    //       name: prop,
    //       value: info.info[prop]
    //     }
    //     this.info.push(obj)
    //   })
    // },
    // pagesRendered(pdfApp) {
    //   setTimeout(() => (pdfApp.pdfViewer.currentScaleValue = 'page-actual'))
    // },
    // closePdf() {
    //   this.pdfDialog = false
    //   this.isPdfOpen = false
    //   this.showPdf = false
    // },

    downloadDokumen() {
      // if (this.detail.file !== null) {
      //   if (this.detail.file.length > 0) {
      setTimeout(() => {
        this.dokumenDialog = true
      }, 300)
      //   } else {
      //     this.showMsgDialog('warning', 'Belum ada file yang diupload', false)
      //   }
      // } else {
      //   this.showMsgDialog('warning', 'Belum ada file yang diupload', false)
      // }
    },
    readyToDownload(fileLink) {
      window.open(fileLink.file, '_blank')
    },
    unlinkDokumen(fName, pValue) {
      this.loading = true
      const data = {
        module: 'pjca',
        file_name: fName
      }
      axios
        .post(`${this.upload}esanqua/procurement/unlink`, data)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.fileNameRab = ''
            if (pValue === undefined) {
              this.removeFileFromDetail(fName)
            }
          } else {
            this.showMsgDialog('warning', res.data.status_msg, false)
            if (pValue === undefined) {
              if (res.data.status_msg === 'File not found') {
                this.removeFileFromDetail(fName)
              }
            }
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog('error', err.message, false)
        })
    },
    removeFileFromDetail(fName) {
      for (let i = 0; i < this.detail.file.length; i++) {
        if (this.detail.file[i].file.includes(fName)) {
          this.detail.file.splice(i, 1)
        }
      }
      this.updatePhoto(false)
    },
    closeDokumenDialog() {
      setTimeout(() => {
        this.dokumenDialog = false
      }, 300)
    },

    uploadDoc(event) {
      if (event === 'upload') {
        setTimeout(() => {
          this.rabDialog = true
        }, 500)
      }
      if (event === 'close') {
        if (this.fileNameRab !== '') {
          let fName = ''
          fName = this.fileNameRab
          this.unlinkDokumen(fName, true)
          this.file_subject = null
          // this.$refs.uploadDoc.reset()
        }
        this.$refs.entryFormUpload.reset()
        setTimeout(() => {
          this.rabDialog = false
        }, 500)
      }
      this.fileNameRab = ''
    },
    uploadFileDoc(event) {
      if (event !== null) {
        if (event.size <= 1024 * 1024 * 2) {
          this.loading = true
          const data = new FormData()
          data.append('file', event)
          data.append('module', 'pjca')
          axios
            .post(`${this.upload}esanqua/procurement`, data)
            .then((res) => {
              if (res.data.status === true) {
                this.showMsgDialog(
                  'success',
                  'File siap disimpan, Silahkan lanjutkan dengan klik tombol "simpan file"',
                  false
                )
                this.fileNameRab = res.data.data.name
                // setTimeout(() => {
                //   this.submitUploadDoc()
                // }, 200)
              } else {
                this.showMsgDialog('warning', res.data.message, false)
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog('error', err.message, false)
            })
        } else {
          setTimeout(() => {
            this.showMsgDialog('warning', 'Max size = 2MB', false)
            this.fileNameRab = ''
          }, 300)
        }
      } else {
        this.fileNameRab = ''
        // this.$refs.uploadDoc.reset()
      }
    },
    submitUploadDoc() {
      this.rules.docRules = [(v) => !!v || 'Tidak ada file yang terupload']
      this.rules.subjectRules = [(v) => !!v || 'Kolom Subject diperlukan']
      const self = this
      setTimeout(function () {
        if (self.$refs.entryFormUpload.validate()) {
          self.updatePhoto(true)
        }
      })
    },
    async updatePhoto(isAddFile) {
      this.loader = 'loading'

      const l = this.loader
      this[l] = !this[l]
      const file = []
      if (this.detail.file != null) {
        for (let i = 0; i < this.detail.file.length; i++) {
          const fName = this.detail.file[i].file.slice(
            this.detail.file[i].file.lastIndexOf('/') + 1
          )
          file.push({
            subject: this.detail.file[i].subject,
            file: fName
          })
        }
      }
      if (isAddFile) {
        file.push({
          subject: this.file_subject,
          file: this.fileNameRab
        })
      }
      const form = {
        id: this.$route.params.id,
        file: file
      }
      await axios
        .post(`${this.proc}pjca/update_file_upload`, form)
        .then((res) => {
          this[l] = false
          if (res.data.status_code === '00') {
            this.showMsgDialog('success', 'File berhasil disimpan', false)
            this.file_subject = null
            this.fileNameRab = ''
            document.getElementById('closeFileUpload').click()
            this.loadPage()
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
            this.unlinkDokumen(this.fileNameRab)
          }
        })
        .catch((err) => {
          this.showMsgDialog('error', err.message, false)
          this[l] = false
          this.fileNameRab = ''
          this.$refs.entryFormUpload.reset()
        })
      this.loader = null
      this.isEdit = false
    },
    async deleteAllFile() {
      this.showMsgDialog(
        'question',
        'Semua file akan terhapus, Anda yakin ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id,
            file: []
          }
          await axios
            .post(`${this.proc}pjca/update_file_upload`, form)
            .then((res) => {
              if (res.data.status_code === '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.loadPage()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.loading = false
              setTimeout(() => {
                this.dokumenDialog = false
              }, 300)
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog('error', err.message, false)
            })
        }
      })
    },
    checkBeforeFetch() {
      if (
        (this.detail.status == 0 || this.detail.status == 1) &&
        this.getUserProfile != null &&
        this.getUserProfile.employee != null &&
        this.getUserProfile.employee.company != null &&
        (this.getUserProfile.employee.company.id == 5 ||
          this.getUserProfile.employee.company.id == 6)
      ) {
        this.getApprovalMatrixDropdown('')
        setTimeout(() => {
          this.selectApprovalDialog = true
        }, 300)
      } else {
        this.fetchMatrix()
      }
    },
    async getApprovalMatrixDropdown(v) {
      this.dropdownApprovalMatrix = []
      const url = `${this.oAuth}approval_matrix/dropdown?keyword=${v}&table_name=tr_pjcas`
      // url = url + `&company_id=${this.detail.company.id}`
      // url = url + `&department_id=${detail.department.id}`
      axios
        .get(url)
        .then((res) => {
          // console.log('approval matrix>>>', url)
          if (res.data.status_code === '00') {
            return (this.dropdownApprovalMatrix = res.data.data)
          }
          return (this.dropdownApprovalMatrix = [])
        })
        .catch((err) => {
          this.dropdownApprovalMatrix = []
          return console.log(err)
        })
    },
    closeApprovalDialog() {
      this.approval_matrix_id = null
      this.approvalSearch = null
      this.approvalSelect = null
      this.dropdownApprovalMatrix = []

      setTimeout(() => {
        this.selectApprovalDialog = false
      }, 300)
    },
    openStoreLink(prdDetail) {
      if (prdDetail != null && prdDetail.store_link) {
        window.open(prdDetail.store_link, '_blank')
      } else {
        this.showMsgDialog('info', 'Link toko tidak tersedia', false)
      }
    },
    editStoreLink() {
      this.showMsgDialog(
        '',
        '',
        true,
        'textarea',
        undefined,
        'Simpan',
        'Batal',
        undefined,
        'Masukkan link toko pada kolom dibawah ini'
      ).then((res) => {
        if (res.isConfirmed) {
          let value = null
          const arrIds = []
          if (res.value) {
            value = res.value
          } else {
            this.selectedData = []
            this.actionValue = 0
            return this.showMsgDialog(
              'warning',
              'Link toko tidak boleh kosong',
              false
            )
          }
          for (let i = 0; i < this.selectedData.length; i++) {
            const element = this.selectedData[i]
            if (element.purchase_request_detail != null) {
              arrIds.push(element.purchase_request_detail.id)
            }
          }
          const form = {
            act: 'update',
            ids: arrIds,
            store_link: value
          }
          console.log('edit store link', form)
          axios
            .post(`${this.proc}fpb/save_detail_link`, form)
            .then((res) => {
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.loadPage()
              } else {
                this.showMsgDialog('error', res.data.status_msg, false)
              }
              this.selectedData = []
            })
            .catch((err) => {
              this.showMsgDialog(
                'error',
                `Something went wrong, Please contact an admin!: ${err.message}`,
                false
              )
            })
        }
        this.actionValue = 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.item-relative {
  position: relative;
}
.mid-border {
  width: 200%;
  height: 1.5px;
  background-color: rgb(253, 69, 69);
  position: absolute;
  top: 50%;
  left: -20px;
}
.pjca-title {
  position: relative;
  top: 10px;
  margin: 0;
  // width: 50%;
  font-weight: bold;
  // text-align: center;
  font-size: 20px;
}
.items-total-div-2 {
  // padding: 10px 0;
  width: '40%';
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  column-gap: 20px;
  .items-difference-box {
    flex-grow: 1;
  }

  .items-total-box {
    border: 1px solid #e0e0e0;
    padding: 20px 10px;
    width: 400px;
    display: flex;
    // margin: auto;
    flex-direction: column;
    // justify-content: center;
    // align-items: flex-end;
    font-size: 14px;
    div {
      border-bottom: 1px solid #e0e0e0;
      width: 100%;
      padding-top: 20px;
      display: flex;
      p {
        margin: 0;
        margin-right: 10px;
        min-width: 160px;
        position: relative;
        span {
          position: absolute;
          right: 0;
        }
      }
    }
  }
}
.items-total-div-3 {
  padding: 0 10px;
  width: 60%;
  font-size: 14px;
}
.actionButton {
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-left: 15px;
}
.fpb-status-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.category-line {
  margin: 10px 0 10px 0;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  line-height: 75px;
}
@media (max-width: 1200px) {
  .category-line-item {
    margin-bottom: 10px;
  }
}
@media (max-width: 808px) {
  .actionButton {
    justify-content: center;
    align-items: flex-start;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    z-index: 2;
    padding: 10px 0;
  }
  .items-total-div-2 {
    width: '100%';
    .items-total-box {
      width: 100%;
    }
  }

  .items-total-div-3 {
    margin-top: 10px;
    width: 100%;
  }
  .tipe-proses {
    margin-top: 5px;
  }
}

@media (max-width: 840px) {
  .fpb-status-section {
    // flex-direction: column;
    flex-wrap: wrap;
  }
}
@media (max-width: 780px) {
  .pjca-title {
    font-size: 3vw;
  }
}
</style>
